import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { validateFinnishSSN } from '../../../../../utils/Finland/validateFinnishSSN';

export const socialSecurityNumberFieldOptions = {
  registerOptions: {
    required: 'SocialSecurityNumber.error.required',
    validate: (value) => {
      if (!validateFinnishSSN(value))
        return 'SocialSecurityNumber.error.pattern';
    },
    setValueAs: (value: string) => value.toLocaleUpperCase().trim(),
  },
  tooltipValidation: {
    message: 'SocialSecurityNumber.tooltip',
  },
} satisfies IFieldOptions;
